var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m29.308 26.125.514-3.258h-3.215v-2.114c0-.89.45-1.76 1.89-1.76h1.461V16.22S28.632 16 27.364 16c-2.648 0-4.379 1.56-4.379 4.385v2.482h-2.943v3.258h2.943V34h3.622v-7.875z"
  })));
};
export default SvgFacebook;